const nsxss = {
  defaultLanguage: 'en',
  translations: {
    en: {
      title: 'Stop!',
      subtitle: 'If someone told you to copy-paste something here, they are trying to trick you.',
      warn: 'Pasting something here can give attackers access to your account.',
      info: 'Unless you understand exactly what you are doing, close this window and stay safe.\n\nFor more information, visit https://en.wikipedia.org/wiki/Self-XSS'
    }
  },

  getBrowserLanguage: () => {
    let lang = navigator.language || navigator.userLanguage || 'en';
    return lang.toLowerCase().substring(0, 2);
  },

  getTranslation: () => {
    let lang = nsxss.getBrowserLanguage();
    let translation = nsxss.translations[lang];
    if (!translation) {
      translation = nsxss.translations[nsxss.defaultLanguage];
    }
    return translation;
  },

  printWarn: () => {
    const { title, subtitle, warn, info } = nsxss.getTranslation();
    
    const styles = {
      title: 'color: red; font-size: 48px; font-weight: bold; -webkit-text-stroke: 1px black;',
      subtitle: 'color: red; font-size: 24px; font-weight: bold;',
      warn: 'color: white; font-size: 16px; font-weight: bold;',
      info: 'color: white; font-size: 14px;'
    };

    console.clear();
    console.log(`%c${title}`, styles.title);
    console.log(`%c${subtitle}`, styles.subtitle);
    console.log(`%c${warn}`, styles.warn);
    console.log(`%c${info}`, styles.info);
  }
};

// Detect devtools
const detectDevTools = () => {
  const threshold = 160;
  const checkDevTools = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    if (widthThreshold || heightThreshold) {
      nsxss.printWarn();
    }
  };

  window.addEventListener('resize', checkDevTools);
  setInterval(checkDevTools, 1000);
};

export { detectDevTools };